import httpService from "../../Service/httpService";

const controller = "Agenda";

export const getWeeklyCalendar = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/getWeeklyCalendar`, {
		...data,
	});
	return res;
};